"use client";
import { useState } from "react";
import Logo from "./Logo";
import MenuBarButton from "./MenuBarButton";
import Navigation from "./Navigation";
import LetsCall from "./letsCall";
import PropTypes from "prop-types";

function Header({ links, className, srcImg, logoTxt }) {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <header
      className={`font-grotesk fixed top-0 z-50 mx-auto box-border w-full flex-1 items-center justify-center px-4 py-4 ${className}`}
    >
      <div className="flex justify-between text-gray-200 md:px-5">
        <Logo />

        <div className="nav-div flex items-center gap-8">
          <Navigation
            setShowMenu={setShowMenu}
            links={links}
            showMenu={showMenu}
          />
          <LetsCall />
        </div>

        <MenuBarButton setShowMenu={setShowMenu} showMenu={showMenu} />
        {showMenu && (
          <div
            onClick={() => setShowMenu(false)}
            className={`backdropBlur absolute top-20 z-10 h-screen w-full md:top-0 ${
              showMenu ? "backdrop-blur-sm" : ""
            } transition duration-1000`}
          />
        )}
      </div>
    </header>
  );
}

export default Header;
Header.propTypes = {
  links: PropTypes.array,
  className: PropTypes.string,
  srcImg: PropTypes.string,
  nameTxt: PropTypes.string,
};
